<template>
    <div class="pagination">
        <div class="pagination__amount">
          Страница {{ currentPage }} из {{ lastPage }}
        </div>
        <div class="pagination__nav">
            <button class="pagination__btn" :disabled="isFirstPage" @click.stop="getPage(currentPage - 1)">
              <svg class="arrow-prev-icon" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.023 7.96802L1.99946 8.04702M1.99946 8.04702L7.22547 2.97317M1.99946 8.04702L7.3552 13.5634"
                      stroke-width="1.5" />
              </svg>
            </button>
            <ul class="pagination__list">
              <li class="pagination__item">
                <a
                  class="pagination__link"
                  :class="{'pagination__link--current': currentPage === 1}"
                  @click="getPage(1)"
                >
                  1
                </a>
              </li>

              <li v-if="currentPage > 4 && lastPage > 5">...</li>

              <li class="pagination__item"
                v-for="page in pagination"
                :key="page"
              >
                <a
                  class="pagination__link"
                  :class="{'pagination__link--current': currentPage === page}"
                  @click="getPage(page)"
                >
                  {{ page }}
                </a>
              </li>

              <li v-if="lastPage > 5 && currentPage < lastPage - 2">...</li>

              <li class="pagination__item" v-if="lastPage !== 1">
                <a
                  class="pagination__link"
                  :class="{'pagination__link--current': currentPage === lastPage}"
                  @click="getPage(lastPage)"
                >
                  {{ lastPage }}
                </a>
              </li>
            </ul>
            <button class="pagination__btn" :disabled="isLastPage" @click.stop="getPage(currentPage + 1)">
              <svg class="arrow-next-icon" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.23486 8.03198L15.2584 7.95298M15.2584 7.95298L10.0323 13.0268M15.2584 7.95298L9.90262 2.43663"
                      stroke-width="1.5" />
              </svg>
            </button>
        </div>
    </div>
</template>

<script>
export default {
  name: 'VPagination',
  props: {
    dispatchName: {
      type: String,
      required: false,
      default: ''
    },
    pages: {
      type: Array,
      required: false,
      default: () => {}
    },
    pageList: Object,
    currentPage: Number
  },
  computed: {
    lastPage () {
      if (this.pages) return this.pages.length

      return this.pageList.pages.length
    },

    isFirstPage () {
      return this.currentPage === 1
    },

    isLastPage () {
      return this.currentPage === this.lastPage
    },

    pagination () {
      const pages = this.pages ? this.pages : this.pageList.pages
      if (this.currentPage < 5) return pages.filter(page => page > 1 && page < 5 && page !== this.lastPage)
      if (this.currentPage > this.lastPage - 3) return pages.filter(page => page > this.lastPage - 4 && page !== this.lastPage)
      return pages.filter(page => page >= this.currentPage - 1 && page <= this.currentPage + 1)
    }
  },
  methods: {
    getPage (pageNum) {
      if (this.dispatchName) {
        this.$store.dispatch(this.dispatchName, pageNum)
      } else {
        this.$emit('get-page', pageNum)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  flex-flow: row nowrap;
  gap: 60px;
  user-select: none;

  @media screen and (max-width: $mobile_start)  {
    font-size: 14px;
  }

  &__amount {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: $font_color_second;
  }

  &__nav {
    display: flex;
    gap: 10px;
    flex-flow: row nowrap;
    align-items: center;
  }

  &__list {
    display: flex;
    gap: 7px;
  }

  &__link {
    cursor: pointer;

    &--current {
      color: $color_second-light;
    }
  }

  &__btn {
    padding: 0;
    color: $color_second-light;
    cursor: pointer;

    &[disabled] {
      color: $color_deactive;
      pointer-events: none;
    }
  }
}
</style>
